// Fleet page: the groups for the filter and the jobs line (Service package). Off: the hooks read nothing.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { todayView, isoDay } from './core'

export function useFleetGroups(on) {
  const [g, setG] = useState({ groups: [], members: [] })
  useEffect(() => {
    if (!on) return
    Promise.all([supabase.from('vessel_groups').select('id,name').order('name'), supabase.from('vessel_group_members').select('group_id,client_id')])
      .then(([a, b]) => setG({ groups: a.data || [], members: b.data || [] })).catch(() => {})
  }, [on])
  return g
}
export const inFleetGroup = (fg, groupId, vesselId) => !groupId || fg.members.some(m => m.group_id === groupId && String(m.client_id) === String(vesselId))
// the fleet overview's jobs line: today, overdue, waiting for the owner (the same counts as Jobs > Today); null while off or not read yet
export function useFleetJobsToday(on, scope) {
  const [d, setD] = useState(null)
  useEffect(() => {
    if (!on) return
    Promise.all([supabase.from('work_orders').select('id,client_id,status,scheduled_date,source').limit(2000), supabase.from('work_order_estimates').select('work_order_id,status,sent_at,reminded_at').eq('status', 'sent').limit(500)])
      .then(([a, b]) => setD({ jobs: a.data || [], estimates: b.data || [] })).catch(() => {})
  }, [on])
  if (!on || !d) return null
  const ids = new Set(scope.map(v => String(v.id)))
  const t = todayView({ jobs: d.jobs.filter(j => ids.has(String(j.client_id))), estimates: d.estimates, today: isoDay(Date.now() - new Date().getTimezoneOffset() * 6e4) })
  return { today: t.today.length, overdue: t.overdue.length, waiting: t.waiting.length }
}
